import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";
const axiosInstance = getAxiosInstance();

// Analytics tracking functions
export const trackViewAPI = (data) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post("/api/analytics/track/view", data, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const trackShareAPI = (data) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post("/api/analytics/track/share", data, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const trackPurchaseAPI = (data) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post("/api/analytics/track/purchase", data, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Analytics data fetching functions
export const getAnalyticsOverviewAPI = (params = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/analytics/overview", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
                params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const getViewsAnalyticsAPI = (params = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/analytics/views", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
                params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const getSharesAnalyticsAPI = (params = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/analytics/shares", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
                params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const getPurchasesAnalyticsAPI = (params = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/analytics/purchases", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
                params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};
